import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { DigitalState, RootState } from './digital-types';

export const state: DigitalState = {
  digital: undefined,
  error: false,
};

const namespaced = true;

export const digital: Module<DigitalState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
